/**
 * Envío de eventos a GA4 (gtag) sólo con consentimiento analítico.
 * Nunca enviar datos personales (nombre, teléfono, correo, mensaje).
 */
import { hayAnalitica } from "@/lib/consent";

type Params = Record<string, string | number | boolean>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const yaEnviado = new Set<string>();

export function track(evento: string, params: Params = {}) {
  if (typeof window === "undefined") return;
  if (!hayAnalitica()) return; // sin consentimiento: no-op
  try {
    window.gtag?.("event", evento, params);
  } catch {
    /* si gtag no está disponible, el sitio no debe fallar */
  }
}

/** Igual que track, pero evita duplicar el mismo evento en la sesión de página. */
export function trackOnce(clave: string, evento: string, params: Params = {}) {
  if (yaEnviado.has(clave)) return;
  yaEnviado.add(clave);
  track(evento, params);
}
